import type { DropdownThemeType } from "./types";

export const dropdownTheme: DropdownThemeType = {
    variant: "bordered",
    color: "secondary",
    className: "cards-nftpoolpreview",
    itemClasses: {
        base: "",
        wrapper: "",
        title: "",
        description: "",
        shortcut: "",
        selectedIcon: "",
    },
    classNames: {
        base: "",
        heading: "",
        group: "",
        divider: "",
    },
}
